import {basicBaseApi} from "./basicBaseApi";
import {Methods} from '@newview/infrastructure';


export class DatastructureApi extends basicBaseApi {

  public get ControllerName(): any {
    return 'datastructure'
  }

  
  /**
   * 
   * @returns 
   */
  public getDataStructureList(){
    return this.send({},"getDataStructureList",Methods.GET)
  }

  public getListByCode(){
    return this.send({},"getListByCode",Methods.GET)
  }

  public getListBywhfiler(S_Name){
    return this.send({S_Name:S_Name},"getListBywhfiler",Methods.GET)
  }

  
  public geFirstLevel(){
    return this.send({},"geFirstLevel",Methods.GET)
  }

  
  public getLazyList(PId){
    return this.send({PId:PId},"getLazyList",Methods.GET)
  }
  /**
   * 批量保存或修改数据
   */
  public insertOrUpdateList(list){
    return this.send(list,"insertOrUpdateList",Methods.POST)
  }

  /**
   * 根据rootid获取数据
   * @param rootId
   */
  public getListByParams(params){
    return this.send(params,"getListByParams",Methods.GET)
  }


  public getlistByType(param){
    return this.send(param,"getlistByType",Methods.POST)
  }

  public informationWithTyep(param){
    return this.send(param,"informationWithTyep",Methods.GET)
  }

  public GetStructureInforList(Ids){
    return this.send({Ids:Ids},"GetStructureInforList",Methods.GET)
  }
}
